// extracted by mini-css-extract-plugin
module.exports = {"itemLink":"_3-aY3h","suggestion":"_1O6Vw_","container":"_1-a57G","banner":"_3_-w_m","linkList":"_3COQzb"};